// Imported for their side effects: each Bootstrap component module registers
// its `data-bs-*` data-API listeners on `document` at import time, which is
// what drives the markup in the Fluid templates. The bindings themselves are
// unused, hence the disable. (Tooltip has no data-API and still needs a manual
// `new Tooltip(el)` - nothing initialises it today.)
// eslint-disable-next-line no-unused-vars
import { Modal, Dropdown, Collapse, Alert, Tooltip } from 'bootstrap';
import CoreMailDecrypter from './decrypt_helper';
import * as Klaro from 'klaro/dist/klaro-no-css';
import klaroConfig from './klaro_config';
import GLightbox from 'glightbox';
import FlexMasonry from 'flexmasonry/src/flexmasonry.js';
import './countdown'

window.klaro = Klaro;
window.klaroConfig = klaroConfig;

const html = document.documentElement;
const body = document.body;

GLightbox({
  selector: '.lightbox',
  touchNavigation: true,
  loop: true,
  autoplayVideos: true
});

// Handler when the DOM is fully loaded
function init() {

  (new CoreMailDecrypter()).init();

  // mobile menu show/hide
  let menubtn = document.getElementById('dl-menu');
  menubtn && menubtn.addEventListener('click', function () {
    document.getElementById('dl-menu-btn').classList.toggle("active");
    html.classList.toggle("menu-open");
    body.classList.toggle("menu-open");
    document.getElementById('nav').classList.toggle("active");
  });

  // mobile menu enhancements
  // if(DEBUG) console.log('hi');
  const triggers = document.querySelectorAll('#nav ul > li span.trigger');
  const triggerItems = [].slice.call(triggers);
  triggerItems.forEach(function (el) {
    el.addEventListener('click', function (event) {
      event.preventDefault();
        if (el.classList.contains("active")) {
          el.classList.remove('active');
        } else {
          triggerItems.forEach(function (e) {
            e.classList.remove('active');
          });
          el.classList.add("active");
        }
      });
  });

  // sticky menu

  const header = document.getElementsByTagName('header');
  if (header.length) {
    const fromtop = header[0].clientHeight;
    if ( window.scrollY > fromtop && !body.classList.contains('sticky') ) {
      body.classList.add('sticky');
    }
    window.addEventListener('scroll', function() {
      if (window.scrollY > fromtop && !body.classList.contains('sticky')) {
        body.classList.add('sticky');
      } else if (window.scrollY < fromtop) {
        body.classList.remove('sticky');
      }
    });
  }

  FlexMasonry.init('.grid', {
    responsive: true,
    breakpointCols: {
      'min-width: 1280px': 5,
      'min-width: 992px': 4,
      'min-width: 768px': 3,
      'min-width: 576px': 2,
    },
    numCols: 6
  });

  // delegated handler, so it also covers markup injected after load
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('.js-showKlaro');
    if (!trigger) return;
    event.preventDefault();
    Klaro.show();
  });

  if (!body.classList.contains('pagets__plain')) {
    Klaro.setup(klaroConfig);
  }

  // bring all modals out to top-level, so there are no z-index issues
  document.querySelectorAll('.comot-js-modal').forEach(function (modal) {
    body.appendChild(modal);
  });

}

if (document.readyState === "complete" || (document.readyState !== "loading" && !document.documentElement.doScroll)) {
  init();
} else {
  document.addEventListener("DOMContentLoaded", init);
}
